import React, { useState } from 'react';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import { BsDownload } from 'react-icons/bs';
import { CgClipboard } from 'react-icons/cg';
import { Oderpage } from './Oderpage';

export const MyOrders = () => {
  const [showOrderPage, setShowOrderPage] = useState(false)
  const [order, setOrder] = useState(null)

  const ordersData = [
    {
      orderNumber: '199118228191',
      products: [
        { price: '20', name: 'Product 1', img: 'https://images.pexels.com/photos/90946/pexels-photo-90946.jpeg?auto=compress&cs=tinysrgb&w=800' },
        { price: '20', name: 'Product 2', img: 'https://images.pexels.com/photos/4158/apple-iphone-smartphone-desk.jpg?auto=compress&cs=tinysrgb&w=800' },
        { price: '20', name: 'Product 3', img: 'https://images.pexels.com/photos/1470167/pexels-photo-1470167.jpeg?auto=compress&cs=tinysrgb&w=800' },
      ],
      date: 'Sept. 7, 2023',
      price: '$16',
      status: 'Processing',
    },
    {
      orderNumber: '199118228192',
      products: [
        { price: '20', name: 'Microsoft Surface Pro', img: 'https://images.pexels.com/photos/4158/apple-iphone-smartphone-desk.jpg?auto=compress&cs=tinysrgb&w=800' },
      ],
      date: 'Sept. 8, 2023',
      price: '$1200',
      status: 'Paid',
    },
    {
      orderNumber: '199118228192',
      products: [
        { price: '20', name: 'Microsoft Surface Pro', img: 'https://images.pexels.com/photos/4158/apple-iphone-smartphone-desk.jpg?auto=compress&cs=tinysrgb&w=800' },
      ],
      date: 'Sept. 8, 2023',
      price: '$1200',
      status: 'Paid',
    },
    {
      orderNumber: '199118228192',
      products: [
        { price: '20', name: 'Microsoft Surface Pro', img: 'https://images.pexels.com/photos/4158/apple-iphone-smartphone-desk.jpg?auto=compress&cs=tinysrgb&w=800' },
      ],
      date: 'Sept. 8, 2023',
      price: '$1200',
      status: 'Paid',
    },
  ];




  return (
    <div className="w-full lg:px-6 lg:py-8 overflow-x-scroll lg:w-[90%] xl:w-full hidescroll">
      {showOrderPage === false &&
      <>
      <h1 className="font-semibold text-[28px] md:text-[32px]">My Orders ({ordersData.length})</h1>
      <p className="py-2 font-extralight w-3/4 text-lg">Manage your order history</p>
      <div className="relative my-4 hidescroll px-2 rounded-xl border-[#F0F0F0] border-[2px] dark:border  dark:border-[#3d3d3d] overflow-x-auto md:min-w-[800px] py-2">
        <table className="w-full text-sm text-left rtl:text-right">
          <thead className="text-xs  text-gray-700 uppercase dark:text-white dark:bg-[#2F2F2F] bg-[#F2F2F2]">
            <tr>
              <th scope="col" className="px-6 py-3">
                Order No.
              </th>
              <th scope="col" className="px-6 py-3">
                Date
              </th>
              <th scope="col" className="px-6 py-3">
                Price
              </th>
              <th scope="col" className="px-6 py-3">
                Status
              </th>
              <th scope="col" className="px-6 py-3">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {ordersData.map((order, index) => (
              <tr key={index} className={index === 0 || index !== ordersData.length - 1 ? "bg-white border-b-2 dark:border-[#3D3D3D] dark:bg-transparent" : ''}>
                <td onClick={() => {
                  setShowOrderPage(true)
                  setOrder(order)
                  }} className="px-6 cursor-pointer py-4 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                  <div className="flex space-x-1 items-center">
                    {order.products.map(product => (
                      <img className='w-10 rounded' src={product.img} alt="" />
                      ))}
                      <div>

                    <p>{order.orderNumber}</p>
              
                    <p className="font-light">{order.products.length} Products</p>
                      </div>
                  </div>
                </td>
                <td className="px-6 py-4">{order.date}</td>
                <td className="px-6 py-4">{order.price}</td>
                <td className="px-6 py-4">
                  <div className={`rounded-lg px-2 py-1 w-fit ${getStatusColor(order.status)}`}>
                    <p>{order.status}</p>
                  </div>
                </td>
                <td className="px-6 py-4 flex items-center space-x-2">
                  <button onClick={() => {
                    setShowOrderPage(true)
                    setOrder(order)
                    }} className=" bg-[#1c1c1c] text-white dark:bg-[#fff] dark:text-[#1c1c1c] p-2 rounded-lg flex items-center space-x-1 w-fit">
                    <MdOutlineRemoveRedEye />
                    {/* <p>View</p> */}
                  </button>
                  <div className=" bg-[#1c1c1c] text-white dark:bg-[#fff] dark:text-[#1c1c1c] p-2 rounded-lg flex items-center space-x-1 w-fit">
                    <BsDownload />
                    {/* <p>Download</p> */}
                  </div>
                  <div className=" bg-[#1c1c1c] text-white dark:bg-[#fff] dark:text-[#1c1c1c] p-2 rounded-lg flex items-center space-x-1 w-fit">
                    <CgClipboard />
                    {/* <p>Invoice</p> */}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </>
}
    {showOrderPage && 
    <Oderpage setShowOrderPage={setShowOrderPage} order={order} getStatusColor={getStatusColor}/>
    }
    </div>
  );
};

const getStatusColor = (status) => {
  if (status === "Processing") return "bg-[#FFF2B1] text-[#5C4F09] dark:bg-[#5C4F09] dark:text-[#FFE55E] ";
  if (status === "Paid") return "bg-[#CBF0D0] text-[#1D6528] dark:bg-[#175220] dark:text-gray-200";
  return "";
};





